import { render, staticRenderFns } from "./workoutsFeedback.vue?vue&type=template&id=08f1d22a&scoped=true"
import script from "./workoutsFeedback.vue?vue&type=script&lang=js"
export * from "./workoutsFeedback.vue?vue&type=script&lang=js"
import style0 from "./workoutsFeedback.vue?vue&type=style&index=0&id=08f1d22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1d22a",
  null
  
)

export default component.exports